import { render, staticRenderFns } from "./memberCommentBoxExport.vue?vue&type=template&id=a680c06a"
import script from "./memberCommentBoxExport.vue?vue&type=script&lang=js"
export * from "./memberCommentBoxExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports